
import { Component, Vue, Prop } from 'vue-property-decorator'
import KatexText from '@/components/atoms/KatexText.vue'
import KatexUtils, { KatexMixedString } from '@/utils/KatexUtils'

/**
 * latex形式と通常文字列の混在文字列を表示する
 */
@Component({
  components: {
    KatexText,
  },
})
export default class KatexMixedText extends Vue {
  /** 文字列 */
  @Prop()
  private src!: string

  /**
   * 文字列を要素ごとに分割した配列
   *
   * @returns 分割結果
   */
  private get parsedTexts(): KatexMixedString[] {
    return KatexUtils.parse(this.src)
  }
}
